export type HeaderFooterDetailId = 'page' | 'total' | 'documentName' | 'documentVersion' | 'pageOfTotal';

export interface HeaderFooterVariable {
  id: HeaderFooterDetailId;
  label: string;
  token: string;
}

export interface DocumentVariables {
  documentName: string;
  documentVersion: string;
}

export const HEADER_FOOTER_VARIABLES: HeaderFooterVariable[] = [
  { id: 'page', label: 'Page number', token: '{page}' },
  { id: 'total', label: 'Page count', token: '{total}' },
  { id: 'documentName', label: 'Document name', token: '{documentName}' },
  { id: 'documentVersion', label: 'Document version', token: '{documentVersion}' },
];

export const HEADER_FOOTER_DETAILS: HeaderFooterVariable[] = [
  ...HEADER_FOOTER_VARIABLES,
  { id: 'pageOfTotal', label: 'Page X of Y', token: 'Page {page} of {total}' },
];

const tokenRegex = (ids: string[]): RegExp => new RegExp(`\\{(?:${ids.join('|')})\\}`, 'g');

export const allTokensRegex = (): RegExp => tokenRegex(HEADER_FOOTER_VARIABLES.map(({ id }) => id));

export const resolveDocumentTokens = (text: string, variables: DocumentVariables): string =>
  text.replace(tokenRegex(Object.keys(variables)), (token) => variables[token.slice(1, -1) as keyof DocumentVariables]);
